// Mock data for VSMB & Associates website

export const firmInfo = {
  name: "VSMB & ASSOCIATES, CHARTERED ACCOUNTANTS",
  fullName: "M/s. VSMB & ASSOCIATES, CHARTERED ACCOUNTANTS",
  tagline: "Growing with Your Success Since 1989",
  established: "1989",
  location: "10-2-195, VAG Ganesh Complex, 2nd Floor, Opp. Deccan Club, East Marredpally, Secunderabad-500026",
  about: "VSMB & ASSOCIATES, CHARTERED ACCOUNTANTS is a dynamic and growing Chartered Accountancy firm established in 1989. With three Fellow Chartered Accountant partners and a dedicated team of experienced professionals, we continue to expand our expertise and services. We serve a diverse and growing clientele including corporate houses, businesses across sectors, non-profit organizations, High Net Worth Individuals (HNIs), and Non-Resident Indians (NRIs)."
};

export const services = [
  {
    id: 1,
    title: "Audit & Assurance",
    description: "Comprehensive audit services including statutory audits, tax audits, internal audits, and bank branch audits. We are registered as Category-II auditors for Statutory Bank Audits.",
    icon: "FileCheck",
    features: [
      "Statutory Audits",
      "Tax Audits",
      "Internal Audits",
      "Bank Branch Audits",
      "Corporate Audits",
      "GST Audits"
    ]
  },
  {
    id: 2,
    title: "Taxation",
    description: "Expert guidance on Income Tax, GST, tax planning, and representation before tax authorities including Income Tax Appellate Tribunal.",
    icon: "Calculator",
    features: [
      "Income Tax Compliance",
      "GST Services",
      "Tax Planning & Advisory",
      "Tax Litigation",
      "International Taxation",
      "Tax Return Filing"
    ]
  },
  {
    id: 3,
    title: "Business Advisory",
    description: "Strategic business advisory services to help you navigate complex financial decisions and optimize your business operations.",
    icon: "Briefcase",
    features: [
      "Strategic Planning",
      "Financial Advisory",
      "Business Consulting",
      "Legal Documentation",
      "Property Transactions",
      "Compliance Advisory"
    ]
  },
  {
    id: 4,
    title: "Accounting Support",
    description: "Complete accounting support services to maintain accurate financial records and ensure regulatory compliance.",
    icon: "BookOpen",
    features: [
      "Bookkeeping Services",
      "Financial Reporting",
      "Company Law Compliance",
      "Certification Work"
    ]
  }
];

export const industries = [
  { name: "Education & Training", icon: "GraduationCap" },
  { name: "Manufacturing", icon: "Factory" },
  { name: "Infrastructure", icon: "Building2" },
  { name: "Poultry", icon: "Bird" },
  { name: "Retail", icon: "ShoppingBag" },
  { name: "Real Estate & Construction", icon: "Home" },
  { name: "IT Consultancy", icon: "Laptop" },
  { name: "Banking & Finance", icon: "Building" }
];

export const partners = [
  {
    id: 1,
    name: "V. Srinivas",
    qualification: "B.Com., F.C.A.",
    designation: "Founder",
    experience: "Over 3 Decades",
    expertise: [
      "Taxation (Income Tax, GST)",
      "Tax Planning",
      "Audit & Assurance",
      "Legal Documentation",
      "Advisory & Litigation"
    ],
    description: "With over three decades of experience, V. Srinivas specializes in taxation, audit, and legal documentation. He represents clients before tax authorities including the Income Tax Appellate Tribunal."
  },
  {
    id: 2,
    name: "Y.V. Bhanu Narayan Rao",
    qualification: "B.Com., F.C.A., D.I.S.A.",
    designation: "Co-Founder",
    experience: "Over 3 Decades",
    expertise: [
      "Taxation & Tax Planning",
      "Information Systems Audit (DISA)",
      "International Taxation (CITAX)",
      "Audit Services"
    ],
    description: "A distinguished professional with over three decades of experience, serving as Member of Southern India Regional Council (SIRC) of ICAI. Former Treasurer of SIRC and Chairman of Hyderabad Branch. He is also a faculty member in Direct Taxes for ICAI.",
    achievements: [
      "Member of SIRC, ICAI",
      "Former Treasurer of SIRC",
      "Former Chairman, Hyderabad Branch of SIRC",
      "Faculty Member - Direct Taxes, ICAI"
    ]
  },
  {
    id: 3,
    name: "R. Purnachander",
    qualification: "B.Com., F.C.A.",
    designation: "Senior Partner",
    experience: "Over 2 Decades",
    expertise: [
      "Income Tax Compliance",
      "GST Compliance",
      "Company Law",
      "Income Tax Audits",
      "Corporate Audits"
    ],
    description: "With more than two decades of professional experience, R. Purnachander specializes in compliance matters including Income Tax, GST, and Company Law, along with audit services."
  }
];

export const coreTeam = [
  {
    name: "Bhagya Lakshmi",
    qualification: "B.Com, A.C.A.",
    experience: "Experienced professional",
    expertise: "Over 10 years with the firm. Tax audits, Income Tax assessments, appeals, filings, corporate audits, and certification work. Previously worked with 'Tax Friday' startup."
  },
  {
    name: "V. Vishal Gupta",
    qualification: "B.Com (H), A.C.A.",
    experience: "Experienced professional",
    expertise: "Corporate audits, Income Tax assessments, appeals, return filings, tax audits, GST audits, and appellate matters. Previously worked with BDO India and ITC Limited."
  },
  {
    name: "Ananya",
    qualification: "B.Com, A.C.A.",
    experience: "Experienced professional",
    expertise: "Corporate audits, Income Tax assessments, appeals, return filings, tax audits, and GST audits."
  }
];

export const strengths = [
  {
    title: "35+ Years of Excellence",
    description: "Established in 1989, we bring over three decades of trusted financial expertise.",
    icon: "Award"
  },
  {
    title: "Experienced Team",
    description: "Three Fellow Chartered Accountant partners with specialized qualifications and a dedicated team of experienced professionals.",
    icon: "Users"
  },
  {
    title: "Diverse Clientele",
    description: "Serving corporate houses, businesses, non-profits, HNIs, and NRIs across multiple industries.",
    icon: "Globe"
  },
  {
    title: "Adaptable & Current",
    description: "Continuously adapting to the latest developments in accounting, taxation, and regulatory frameworks.",
    icon: "TrendingUp"
  },
  {
    title: "Professional Recognition",
    description: "Active participation in ICAI with partners holding key positions in regional council.",
    icon: "Medal"
  },
  {
    title: "Client Satisfaction",
    description: "Large base of satisfied clients built on trust, integrity, and professional excellence.",
    icon: "ThumbsUp"
  }
];

export const values = [
  {
    title: "Integrity",
    description: "",
    icon: "Shield"
  },
  {
    title: "Independence",
    description: "",
    icon: "Scale"
  },
  {
    title: "Professionalism",
    description: "",
    icon: "Star"
  },
  {
    title: "Knowledge",
    description: "",
    icon: "BookOpen"
  }
];

export const contactInfo = {
  address: "10-2-195, VAG Ganesh Complex, 2nd Floor, Opp. Deccan Club, East Marredpally, Secunderabad-500026",
  phone: "040-40175966",
  email: "vsmbandassociates@gmail.com",
  hours: "Monday - Saturday: 10:00 AM - 6:00 PM"
};
